// extracted by mini-css-extract-plugin
export default {"table":"Table_table__-qQCZ","cellChipWrapper":"Table_cellChipWrapper__t8cai","header":"Table_header__6OYf0","processingRow":"Table_processingRow__4YwIj"};